import React, {Component} from 'react';
// eslint-disable-next-line
import PropTypes from 'prop-types';
import moment from 'moment';

import './Datepicker.css';

export default class Datepicker extends Component {

    constructor(props){
        super(props);

        this.state = {
            id: `datepicker_${this.props.id}___${parseInt(Math.random() * 100000, 10)}`
        }
    }

    componentDidMount() {
        this._initializePicker(true);
    }

    componentWillReceiveProps(nextProps){
        if(this.props.alwaysRestart || nextProps.alwaysRestart){
            /*eslint-env jquery*/
            let picker = $("#" + this.state.id).pickadate("picker");
            setTimeout(() => {
                picker.stop();
                this._initializePicker(false);
            }, 100);
        }

        if(this.props.value && !nextProps.value){
            let picker = $("#" + this.state.id).pickadate("picker");
            setTimeout(() => {
                picker.stop();
                this._initializePicker(false);
            }, 100);
        }
    }

    _initializePicker = (init) => {

        let onSetFunction = function (context) {
            if (context['select']) {
                // Date selected
                this.close();
            }
        };
        if(this.props.hideDays){
            onSetFunction = function (context) {
                if (context['highlight']) {
                    // Date selected
                    this.set('select', [context['highlight'][0], context['highlight'][1],1]);
                }
            };
        }

        let config = {
            format: this.props.pickerFormat,
            selectMonths: true,
            selectYears: true,
            onSet: onSetFunction,
            monthsFull: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            weekdaysFull: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'],
            weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
            today: 'Hoy', // text for done-button
            clear: 'Limpiar', // text for clear-button
            close: 'Ok', // Text for cancel-button,
            closeOnSelect: true
        };

        if(this.props.min)config['min'] = this.props.min;
        if(this.props.max)config['max'] = this.props.max;

        /*eslint-env jquery*/
        $(`#${this.state.id}`).pickadate(config);
        if(init){
            /*eslint-env jquery*/
            $(`#${this.state.id}`).on('change', this._setValues);
        }
    };

    _openPicker = () => {
        this.props.openAction();
        /*eslint-env jquery*/
        let picker = $("#" + this.state.id).pickadate("picker");
        setTimeout(picker.open, 100);
    };

    _setValues = (ev) => {
        let value = moment(ev.target.value, this.props.momentFormat).format(this.props.format);
        this.props.action(this.props.id, value);
    };


    render() {

        let showValue = '';
        if(this.props.placeholder){
            showValue = <span className={"grey-text"}>{this.props.placeholder}</span>
        }
        if(this.props.value){
            showValue = moment(this.props.value, this.props.format).format(this.props.momentFormat);
        }

        let {classname, hideDays} = this.props;
        if(hideDays){
            classname += ' hide-days-picker';
        }

        return (
            <div className={classname} style={this.props.style}>

                {/* --- Display FakeInput --- */}
                <div className={'pointer'} onClick={this._openPicker}>
                    <p className={"field-p"}>{showValue}</p>
                    <div style={{position: 'absolute', top: 13, right: 15}}>
                        <i className="material-icons grey-text">
                            calendar_today
                        </i>
                    </div>
                </div>

                {/* --- Hidden Input --- */}
                <input style={{display: 'none'}} type="text"
                       id={this.state.id} value={this.props.value}
                       onChange={() => {}}
                />
            </div>
        );

    }
}

Datepicker.propTypes = {
};

Datepicker.defaultProps = {
    pickerFormat: 'dd/mm/yyyy',
    momentFormat: 'DD/MM/YYYY',
    format: 'DD/MM/YYYY',
    hideDays: false,
    openAction: () => {}
};



// WEBPACK FOOTER //
// ./src/components/Datepicker/datepicker.js